var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { TextField, Box, useTheme, } from "@mui/material";
import { Controller, } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IMaskInput } from "react-imask";
import { ErrorMessage } from "./ValidationMessage";
const PhoneMaskCustom = React.forwardRef(function PhoneMaskCustom(props, ref) {
    const { onChange, value } = props, other = __rest(props, ["onChange", "value"]);
    return (React.createElement(IMaskInput, Object.assign({}, other, { mask: "+{31} 000000000", definitions: {
            "0": /[0-9]/,
        }, inputRef: ref, value: value || "", onAccept: (value) => {
            onChange(value);
        }, overwrite: true, placeholder: "+31 612345678" })));
});
export const FPhoneInput = (_a) => {
    var { name, control, label, error, helperText, hiddenLabel, size = "medium", placeholder = "+31 612345678" } = _a, props = __rest(_a, ["name", "control", "label", "error", "helperText", "hiddenLabel", "size", "placeholder"]);
    const { t } = useTranslation(["form", "validation", "common"]);
    const theme = useTheme();
    const getValidationMessage = (fieldError) => (fieldError === null || fieldError === void 0 ? void 0 : fieldError.message) || helperText;
    return (React.createElement(Controller, { name: name, control: control, rules: props.rules, render: ({ field, fieldState: { error: fieldError } }) => {
            var _a;
            return (React.createElement(Box, { width: "100%" },
                React.createElement(TextField, Object.assign({}, props, { hiddenLabel: hiddenLabel, required: false, label: !hiddenLabel ? (React.createElement(React.Fragment, null,
                        t(label),
                        props.required && (React.createElement("span", { style: { color: theme.palette.error.main } }, "\u00A0*")))) : undefined, error: !!fieldError || !!error, fullWidth: true, variant: "filled", size: size, 
                    // InputProps={{
                    //   inputComponent: PhoneMaskCustom as any,
                    //   startAdornment: (
                    //     <InputAdornment position="start">🇳🇱</InputAdornment>
                    //   ),
                    // }}
                    inputProps: {
                        value: (_a = field.value) !== null && _a !== void 0 ? _a : "",
                        onChange: field.onChange,
                        name: field.name,
                        placeholder,
                    }, onBlur: field.onBlur, inputRef: field.ref })),
                React.createElement(ErrorMessage, { error: getValidationMessage(fieldError || error) })));
        } }));
};
